import Filter from './filter'

export const FilterGenerator =(props)=>{
  return(
    <Filter {...props}/>
  )
}